import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { CancelButton, EditButtonsContainer, ConfirmButton } from './styled';

class SliderEditorButtons extends PureComponent {
  static propTypes = {
    confirmDisabled: PropTypes.bool.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
  };

  render() {
    const { confirmDisabled, handleConfirm, handleCancel } = this.props;

    return (
      <EditButtonsContainer>
        <CancelButton data-selenium="cancelSplitButton" onClick={handleCancel}>
          Cancel
        </CancelButton>
        <ConfirmButton
          onClick={() => {
            if (!confirmDisabled) handleConfirm();
          }}
          data-selenium="confirmSplitButton"
        >
          Confirm
        </ConfirmButton>
      </EditButtonsContainer>
    );
  }
}

export default SliderEditorButtons;
